import { memo } from "react";
import { Skeleton } from "@crehana/compass.ui";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MetricsSkeleton = function MetricsSkeleton(_ref) {
  var isAnimated = _ref.isAnimated,
    dataTestId = _ref['data-testid'];
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-4",
    "data-testid": dataTestId,
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(Skeleton, {
        animated: isAnimated,
        className: "tw-w-14.4 tw-h-2.4 tw-mb-1"
      }), /*#__PURE__*/_jsx("div", {
        className: "tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-2",
        children: Array.from({
          length: 4
        }).map(function (_, index) {
          return /*#__PURE__*/_jsx(Skeleton, {
            animated: isAnimated,
            className: "tw-w-full tw-h-4 sm:tw-h-11.2 tw-rounded-1"
          }, index);
        })
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "tw-p-1.6",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        animated: isAnimated,
        className: "tw-w-full sm:tw-w-[40%] tw-h-2.4 tw-mb-2 tw-rounded-1"
      }), /*#__PURE__*/_jsx(Skeleton, {
        animated: isAnimated,
        className: "tw-w-full sm:tw-w-[60%] tw-h-2.4 tw-mb-2 tw-rounded-1"
      }), /*#__PURE__*/_jsx(Skeleton, {
        animated: isAnimated,
        className: "tw-w-full sm:tw-w-[30%] tw-h-3.2 tw-rounded-1"
      })]
    })]
  });
};
export default /*#__PURE__*/memo(MetricsSkeleton);